import React from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';

interface TabItemProps {
  title: string;
  content: React.ReactNode;
}

interface ProductTabsProps {
  items: TabItemProps[];
}

const ProductTabs: React.FC<ProductTabsProps> = ({ items }) => {
  return (
    <Tab.Container defaultActiveKey="0" id="productTabs">
      <Row className="product-tabs my-0 my-lg-5" id="productDetails">
        <Col sm={12}>
          <Nav variant="tabs" className="product-tabs__nav border-0 flex-nowrap custom_scrollbar">
            {items.map((item, index) => (
              <Nav.Item key={index} className="d-block">
                <Nav.Link className="h4 p-0 d-block product-tabs__link" eventKey={String(index)}>
                  {item.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Col>
        <Col sm={12}>
          <Tab.Content>
            {items.map((item, index) => (
              <Tab.Pane eventKey={String(index)} key={index}>
                <div className="product-tabs__content py-4">{item.content}</div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default ProductTabs;
